import { render, staticRenderFns } from "./MostCommonFailedBlock.vue?vue&type=template&id=86dafa3a&"
import script from "./MostCommonFailedBlock.vue?vue&type=script&lang=ts&"
export * from "./MostCommonFailedBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports